module.exports = __webpack_public_path__ + "img/Loading_40px_grey.ec0977d1.svg";